var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.094 8.19604H1.15002V25.468H27.094V8.19604Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.094 4.34106H1.15002V4.75006H27.094V4.34106Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02598 12.1201H6.47498C6.3369 12.1201 6.22498 12.232 6.22498 12.3701V14.9211C6.22498 15.0592 6.3369 15.1711 6.47498 15.1711H9.02598C9.16405 15.1711 9.27598 15.0592 9.27598 14.9211V12.3701C9.27598 12.232 9.16405 12.1201 9.02598 12.1201Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02598 18.4922H6.47498C6.3369 18.4922 6.22498 18.6041 6.22498 18.7422V21.2932C6.22498 21.4313 6.3369 21.5432 6.47498 21.5432H9.02598C9.16405 21.5432 9.27598 21.4313 9.27598 21.2932V18.7422C9.27598 18.6041 9.16405 18.4922 9.02598 18.4922Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.398 18.4922H12.847C12.709 18.4922 12.597 18.6041 12.597 18.7422V21.2932C12.597 21.4313 12.709 21.5432 12.847 21.5432H15.398C15.5361 21.5432 15.648 21.4313 15.648 21.2932V18.7422C15.648 18.6041 15.5361 18.4922 15.398 18.4922Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.769 18.4922H19.218C19.0799 18.4922 18.968 18.6041 18.968 18.7422V21.2932C18.968 21.4313 19.0799 21.5432 19.218 21.5432H21.769C21.9071 21.5432 22.019 21.4313 22.019 21.2932V18.7422C22.019 18.6041 21.9071 18.4922 21.769 18.4922Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.398 12.1201H12.847C12.709 12.1201 12.597 12.232 12.597 12.3701V14.9211C12.597 15.0592 12.709 15.1711 12.847 15.1711H15.398C15.5361 15.1711 15.648 15.0592 15.648 14.9211V12.3701C15.648 12.232 15.5361 12.1201 15.398 12.1201Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.769 12.1201H19.218C19.0799 12.1201 18.968 12.232 18.968 12.3701V14.9211C18.968 15.0592 19.0799 15.1711 19.218 15.1711H21.769C21.9071 15.1711 22.019 15.0592 22.019 14.9211V12.3701C22.019 12.232 21.9071 12.1201 21.769 12.1201Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54102 1.30908V3.59408",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.958 1.30908V3.59408",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.3491eb4a8c572e42f9ac84e54a55c099.svg";
export { ForwardRef as ReactComponent };